const formFields = document.querySelectorAll('.form-field')

for (var i = formFields.length - 1; i >= 0; i--) {
  let field = formFields[i]

  field.addEventListener('click', () => {
    const input = field.querySelector('input, textarea')
    if (input.getAttribute("type") === 'radio') {
      input.click()

      if (input.getAttribute("id") !== "donation-amount-choose") {
        input.focus()
      }
    } else {
      input.focus()
    }
  })

  let inputs = field.querySelectorAll('input, textarea')

  for (var i = inputs.length - 1; i >= 0; i--) {
    let input = inputs[i]

    input.addEventListener('focus', () => {
      field.classList.add('has-focus')
    })
    input.addEventListener('blur', () => {
      field.classList.remove('has-focus')
    })
  }
}



const formFieldControlls = document.querySelectorAll(".form-input-ctrl")

for (var i = formFieldControlls.length - 1; i >= 0; i--) {
  let btn = formFieldControlls[i]

  btn.addEventListener("click", () => {
    const input = document.getElementById(btn.getAttribute("data-for"))
    const step = parseFloat(btn.getAttribute("data-step") || 1)

    if (!input) return

    let value = parseFloat(input.value || 100)

    if (btn.classList.contains("form-input-decrease")) {
      value = value - step
    }
    if (btn.classList.contains("form-input-increase")) {
      value = value + step
    }

    if (input.getAttribute("min") && value <= input.getAttribute("min")) return
    if (input.getAttribute("max") && value >= input.getAttribute("max")) return

    input.value = value
    input.dispatchEvent(new Event("input"))
  })

}


// WEBPACK FOOTER //
// ./source/js/components/form.js